import axiosInstance from '../services/axiosInstance';
import { envUrls } from './env';
import { oidcSettings } from '../configs/oidc';

// Uncomment this to test localhost
//  envUrls.usersService = 'http://34.201.36.98:4005/';
// envUrls.usersService = 'http://localhost:3000/';

export default class OIDCAuthService {
  static generateAuthenticationUrl(state) {
    var query = new URLSearchParams();
    query.append('response_type', oidcSettings.oidcResponseType);
    query.append('client_id', oidcSettings.oidcClientId);
    query.append('redirect_uri', oidcSettings.oidcRedirectUrl);
    query.append('scope', oidcSettings.oidcScope);
    query.append('state', state);
    return `${oidcSettings.oidcAuthEndpoint}?${query.toString()}`;
  }

  static async getAuthenticationToken(code) {
    return axiosInstance
      .post(`${envUrls.usersService}auth/oidc/token`, { code: code })
      .then((response) => response.data);
  }

  static async register(payload, token) {
    return axiosInstance
      .post(`${envUrls.usersService}auth/oidc/register`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => response.data);
  }
}
